import React, { Fragment, useState, useCallback } from "react";
import { Button, Modal } from "react-bootstrap";
import MaskForm from "./MaskForm";
import { notifyTopRight, notifyError } from "../../toast/SetToast";
import Toast from "../../toast/SetToast";

const MaskRegister = ({ show, onHide, onAdded }) => {
  const [formValues, setFormValues] = useState({
    maskName: "",
    price: "",
    description: "",
    IsActive: "Active",
  });

  const handleInputChange = useCallback(
    (field) => (e) => {
      setFormValues({
        ...formValues,
        [field]: e.target.value,
      });
    },
    [formValues]
  );

  const validateForm = () => {
    const requiredFields = ["maskName", "price"];
    const missingFields = requiredFields.filter((field) => !formValues[field]);

    if (missingFields.length > 0) {
      notifyError(
        `Please fill all required fields: ${missingFields.join(", ")}`
      );
      return false;
    }
    return true;
  };

  const resetForm = () => {
    setFormValues({
      maskName: "",
      price: "",
      description: "",
      IsActive: "Active",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      onAdded(formValues);
      notifyTopRight("Mask registered successfully", 3000);
      resetForm();
      onHide();
    } catch (error) {
      notifyError("Error registering mask: " + error.message);
      console.error("Error registering mask:", error);
    }
  };

  return (
    <Fragment>
      <Toast />
      <Modal className="fade" show={show} onHide={onHide} centered>
        <Modal.Header>
          <Modal.Title>Register Mask</Modal.Title>
          <Button variant="" className="close" onClick={onHide}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <MaskForm onChange={handleInputChange} />
            <div className="form-group row">
              <div className="col-lg-8 ml-auto">
                <Button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default MaskRegister;
